import React from 'react';
import { Typography, Paper, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { motion } from 'framer-motion';
import styles from './AdminDashboard.module.css';

const InterviewList = ({ filteredInterviews, handleInterviewClick, reviewFilter, handleReviewFilterChange }) => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Interview Reports
      </Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="review-filter-label">Filter by Review Status</InputLabel>
        <Select
          labelId="review-filter-label"
          id="review-filter"
          value={reviewFilter}
          label="Filter by Review Status"
          onChange={handleReviewFilterChange}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="reviewed">Reviewed</MenuItem>
          <MenuItem value="unreviewed">Unreviewed</MenuItem>
        </Select>
      </FormControl>
      <motion.div
        variants={{
          in: { transition: { staggerChildren: 0.07, delayChildren: 0.2 } }
        }}
      >
        {filteredInterviews.map((interview) => (
          <motion.div
            key={interview.id}
            variants={{
              initial: { y: 50, opacity: 0 },
              in: { y: 0, opacity: 1 },
              out: { y: 50, opacity: 0 }
            }}
            transition={{ duration: 0.3 }}
          >
            <Paper
              className={styles.interviewPaper}
              onClick={() => handleInterviewClick(interview)}
            >
              <Typography variant="h6">Interview ID: {interview.id}</Typography>
              <Typography variant="body1">User: {interview.user_id}</Typography>
              <Typography variant="body1">First Name: {interview.first_name}</Typography>
              <Typography variant="body1">Last Name: {interview.last_name}</Typography>
              <Typography variant="body1">Timestamp: {new Date(interview.timestamp).toLocaleString()}</Typography>
              <Typography variant="body1">Review Status: {interview.reviewStatus}</Typography>
            </Paper>
          </motion.div>
        ))}
      </motion.div>
    </>
  );
};

export default InterviewList;
